export default __webpack_public_path__ + "static/media/courier-real.5bacdccb.jpg";